/* eslint-disable import/first */

// Styles
import 'normalize.css/normalize.css';
import 'swiper/swiper-bundle.css';
import './sass/style.scss';

import 'swiper/swiper-bundle.min';
import Site from './js/site';

Site();
